import { useState, useEffect, useRef } from 'react';
import fallbackImg from '../../../../../../public/assets/no-profile-image.png';

export const useImageLoader = (src: string) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const imgRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    setLoading(true);
    setError(false);

    const imgElement = imgRef.current;

    if (imgElement) {
      const handleLoad = () => {
        setLoading(false);
      };

      const handleError = () => {
        setLoading(false);
        setError(true);
        if (fallbackImg) {
          imgElement.src = fallbackImg;
        }
      };

      imgElement.addEventListener('load', handleLoad);
      imgElement.addEventListener('error', handleError);

      return () => {
        imgElement.removeEventListener('load', handleLoad);
        imgElement.removeEventListener('error', handleError);
      };
    }
  }, [src]);

  return { imgRef, loading, error };
};
